import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import useSaleEvent from './useSaleEvent';

interface StyleProps {
  isSaleEvent?: boolean;
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  yearlyDiscount: {
    borderRadius: 16,
    border: `1px solid ${props.isSaleEvent ? '#fff' : theme.palette.primary.main}`,
    color: props.isSaleEvent ? '#fff' : theme.palette.primary.main,
    filter: props.isSaleEvent ? 'brightness(1.0)' : 'brightness(1.3)',
    padding: '2px 3px',
    fontSize: 12,
    width: 'fit-content',
    marginTop: '3px',
    textWrap: 'nowrap',
    alignSelf: 'end',
    margin: '7px 0',
  },
}));

const YearlyDiscountChip: React.FC = () => {
  const { t } = useTranslation();
  const { saleEvent } = useSaleEvent();
  const { classes } = useStyles({ isSaleEvent: !!saleEvent?.styles });
  if (saleEvent) {
    return null;
  }
  return <div className={classes.yearlyDiscount}>{t('home.pricing.yearly_discount')}</div>;
};

export default YearlyDiscountChip;
